import { create } from 'zustand';

interface DevStore {
  isDevMode: boolean;
  toggleDevMode: () => void;
  enableDevMode: () => void;
  disableDevMode: () => void;
}

export const useDevStore = create<DevStore>((set) => ({
  isDevMode: false,
  toggleDevMode: () => set((state) => ({ isDevMode: !state.isDevMode })),
  enableDevMode: () => set({ isDevMode: true }),
  disableDevMode: () => set({ isDevMode: false }),
}));